(function(){
  if (window.innerWidth < 860) {
    $(document).ready(function(){
      if ($('#bc-sf-filter-collection-description')){
        let iconDown = '<span class="collection-description-mob-collapsible-readmore-icon"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8"><g fill="currentColor" fill-rule="evenodd" transform="translate(0 -.5)"><polygon class="icon-chevron-down-left" points="7 8.466 13.655 1.81 12.38 .533 7 5.913"></polygon><polygon class="icon-chevron-down-right" points="7 5.913 1.621 .533 .344 1.81 7 8.466"></polygon></g></svg></span>'
        let iconUp = '<span class="collection-description-mob-collapsible-readmore-icon"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8"><g fill="currentColor" fill-rule="evenodd" transform="translate(0 -.5), rotate(-180 7 4)"><polygon class="icon-chevron-down-left" points="7 8.466 13.655 1.81 12.38 .533 7 5.913"></polygon><polygon class="icon-chevron-down-right" points="7 5.913 1.621 .533 .344 1.81 7 8.466"></polygon></g></svg></span>'
        let currentHtml = $('.collapse_on_mob').html();
        var elementParent = document.getElementsByClassName('collapse_on_mob')[0];
        var pArr = Array.prototype.slice.call(elementParent.getElementsByTagName('p'));
        var spanArr = Array.prototype.slice.call(elementParent.getElementsByTagName('span'));
        var nodes = pArr.concat(spanArr);
        let tempNode = null;
        if (nodes.length) {
          let longestText = 0;
          for (let i in nodes){
            if (nodes[i].textContent.length > longestText){
              longestText = nodes[i].textContent.length;
              tempNode = nodes[i];
            }
          }
        } else {
          tempNode = document.createElement('p');
          tempNode.textContent = elementParent.textContent;
        }
        var tmp = document.createElement("div");
        tempNode.setAttribute('class', 'collapse-content');
        tmp.appendChild(tempNode);
        $('.collapse_on_mob').html('<div class="collection-description-mob-collapsible hidden">' + tmp.innerHTML + currentHtml + '<a class="collection-description-mob-collapsible-readmore hidden"><span class="collection-description-mob-collapsible-readmore-ellipses">...</span>Read more' + iconDown + '</a></div>'); 
        if ($('.collapse_on_mob').find('iframe').length) {
          $('.collapse_on_mob').find('iframe').parents('p').addClass('collapsible-banner-img');
        }
        $('.collection-description-mob-collapsible-readmore').click(function(){
          $('.collection-description-mob-collapsible').toggleClass('hidden');
          $('.collapse_on_mob_img').toggleClass('show');
          $(this).toggleClass('hidden');
          if ($(this).hasClass('hidden')){
            $(this).html('<span class="collection-description-mob-collapsible-readmore-ellipses">...</span>Read more' + iconDown);
            setTimeout(function(){
              $('.collapse-content').show();
            }, 300);
          } else {
            $(this).html('Read less' + iconUp);
            $('.collapse-content').hide();
          }
        })
      }
    })
  }
})();
